import { IReduxAction } from '@bees-web/core/types'
import { SET_OPENED_COLLAPSE_NAME } from '../constants'

export const setOpenedCollapseName = (name: string): IReduxAction => ({
  type: SET_OPENED_COLLAPSE_NAME,
  payload: {
    openedCollapseName: name,
  },
})
